import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

const ReactStars = require('react-rating-stars-component').default;

interface SellerRatingProps {
  averageRating: number;
  reviewsCount: number;
  customRoute: string;
}

const SellerRating: React.FC<any> = ({
  averageRating,
  reviewsCount,
  customRoute,
}: SellerRatingProps): ReactElement => {
  return (
    <>
      <div className="d-flex">
        <ReactStars
          name="rate1"
          starCount={5}
          value={averageRating}
          size={19}
          isHalf={true}
          activeColor={getComputedCSSVariable('yellow')}
          color={getComputedCSSVariable('l-gray')}
          edit={false}
        />
        <p className="my-auto mx-2">
          <small>
            {averageRating}
            {' '}
          </small>
        </p>
        |
        <a className="mx-2 my-auto" href={customRoute || '#seller-reviews'}>
          <small>
            {' '}
            {reviewsCount ?? ''}
            {' '}
            Reviews
          </small>
        </a>
      </div>
    </>
  );
};

if (document.getElementsByClassName('react-seller-rating').length > 0) {
  document.querySelectorAll('.react-seller-rating').forEach((element) => {
    const averageRatingAttr = element.getAttribute('data-average-rating');
    const reviewsCountAttr = element.getAttribute('data-reviews-count');
    const customRoute = element.getAttribute('data-custom-route');
    const averageRating = averageRatingAttr ? parseFloat(averageRatingAttr) : 0;
    const reviewsCount = reviewsCountAttr ? parseInt(reviewsCountAttr, 10) : 0;
    ReactDOM.render(<SellerRating
      averageRating={averageRating}
      reviewsCount={reviewsCount}
      customRoute={customRoute}
    />, element);
  });
}

export default SellerRating;
